/**
 * @generated SignedSource<<e384610d56760512c106543cd87cc4ba>>
 * @relayHash aeb2a85abafaca58a2bf058e3f5ffe3e
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/575.0.0-2026-09-01T15:23:14.547Z/NftProfileImportCollectionViewRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionViewRefetchQuery$variables = {
  fetchUser: boolean;
  hasTokenContractId: boolean;
  tokenContractId: string;
  userId: string;
  username: string;
};
export type NftProfileImportCollectionViewRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionView_viewer">;
  };
};
export type NftProfileImportCollectionViewRefetchQuery = {
  response: NftProfileImportCollectionViewRefetchQuery$data;
  variables: NftProfileImportCollectionViewRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasTokenContractId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tokenContractId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "tokenContractId",
    "variableName": "tokenContractId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v5 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_ERROR"
  ]
},
v6 = [
  (v4/*:: as any*/),
  (v5/*:: as any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ether",
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileName",
      "storageKey": null
    },
    (v1/*:: as any*/)
  ],
  "storageKey": null
},
v15 = [
  (v13/*:: as any*/),
  (v14/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ensDomain",
    "storageKey": null
  },
  (v1/*:: as any*/)
],
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpUrl",
  "storageKey": null
},
v18 = [
  (v13/*:: as any*/),
  (v1/*:: as any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "contractAddress",
  "plural": false,
  "selections": (v18/*:: as any*/),
  "storageKey": null
},
v20 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "auctionId",
    "storageKey": null
  },
  (v11/*:: as any*/),
  (v19/*:: as any*/),
  (v1/*:: as any*/)
],
v21 = [
  (v7/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "NftTokenContractImportCreatedItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "importErrorReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              (v8/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftDigitalArtMetadataMedia",
                    "kind": "LinkedField",
                    "name": "media",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mimeType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "webUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "posterFrameUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "videoThumb",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "edition",
                    "storageKey": null
                  }
                ],
                "type": "NftDigitalArtMetadata",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v10/*:: as any*/),
            "concreteType": "NftAuction",
            "kind": "LinkedField",
            "name": "mostRecentAuction",
            "plural": false,
            "selections": [
              (v11/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EtherAmount",
                "kind": "LinkedField",
                "name": "currentBid",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EtherAmount",
                "kind": "LinkedField",
                "name": "reservePrice",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "winnerAddress",
                "plural": false,
                "selections": (v15/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NftItem",
                "kind": "LinkedField",
                "name": "item",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EtherRates",
                    "kind": "LinkedField",
                    "name": "etherRates",
                    "plural": true,
                    "selections": (v16/*:: as any*/),
                    "storageKey": null
                  },
                  (v1/*:: as any*/),
                  (v17/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NftConversionRateEvent",
                "kind": "LinkedField",
                "name": "endedConversionRates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EtherRates",
                    "kind": "LinkedField",
                    "name": "rates",
                    "plural": true,
                    "selections": (v16/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "creatorAddress",
                "plural": false,
                "selections": (v18/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "sellerAddress",
                "plural": false,
                "selections": (v18/*:: as any*/),
                "storageKey": null
              },
              (v1/*:: as any*/)
            ],
            "storageKey": "mostRecentAuction(excludeCanceled:true)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wasBurned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LinkData",
            "kind": "LinkedField",
            "name": "linkData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "path",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isLinkable",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItemLikes",
            "kind": "LinkedField",
            "name": "likes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "likeCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EthereumAddressType",
            "kind": "LinkedField",
            "name": "creatorAddress",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publicProfileUrl",
                "storageKey": null
              },
              (v14/*:: as any*/),
              (v1/*:: as any*/),
              (v13/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalSupply",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isERC1155",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EthereumAddressType",
            "kind": "LinkedField",
            "name": "ownerAddress",
            "plural": false,
            "selections": (v15/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tokenId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tokenUri",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NftTokenContract",
            "kind": "LinkedField",
            "name": "contract",
            "plural": false,
            "selections": [
              (v9/*:: as any*/),
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "addressWithFields",
                "plural": false,
                "selections": (v18/*:: as any*/),
                "storageKey": null
              },
              (v13/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId"
                  }
                ],
                "concreteType": "NftItemBalance",
                "kind": "LinkedField",
                "name": "balanceForUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "balance",
                    "storageKey": null
                  },
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "ownerAddress",
                    "plural": false,
                    "selections": (v18/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": "recentAuction",
            "args": (v10/*:: as any*/),
            "concreteType": "NftAuction",
            "kind": "LinkedField",
            "name": "mostRecentAuction",
            "plural": false,
            "selections": (v20/*:: as any*/),
            "storageKey": "mostRecentAuction(excludeCanceled:true)"
          },
          (v17/*:: as any*/),
          {
            "alias": "auction",
            "args": (v10/*:: as any*/),
            "concreteType": "NftAuction",
            "kind": "LinkedField",
            "name": "mostRecentAuction",
            "plural": false,
            "selections": (v20/*:: as any*/),
            "storageKey": "mostRecentAuction(excludeCanceled:true)"
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v22 = [
  "importStatuses"
],
v23 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v24 = [
  (v23/*:: as any*/),
  (v5/*:: as any*/)
],
v25 = [
  (v7/*:: as any*/)
],
v26 = [
  (v4/*:: as any*/),
  {
    "kind": "Literal",
    "name": "importStatuses",
    "value": [
      "NFT_ITEM_IMPORT_STATUS_COMPLETE",
      "NFT_ITEM_IMPORT_STATUS_PROCESSING"
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftProfileImportCollectionViewRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftProfileImportCollectionView_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "NftProfileImportCollectionViewRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": "nftBenignNeglect",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftBenignNeglect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
          },
          {
            "alias": "walletConnectFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "allowWalletConnect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "isNftAuctionV2Enabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftAuctionV2"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "username",
                "variableName": "username"
              }
            ],
            "concreteType": "PublicProfile",
            "kind": "LinkedField",
            "name": "publicProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              (v1/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*:: as any*/),
            "concreteType": "NftTokenContractImport",
            "kind": "LinkedField",
            "name": "nftTokenContractImportById",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v1/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "hasTokenContractId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "nftTokenContractImportErrors",
                "args": (v2/*:: as any*/),
                "concreteType": "NftTokenContractImport",
                "kind": "LinkedField",
                "name": "nftTokenContractImportById",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v6/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v21/*:: as any*/),
                    "storageKey": "items(first:20,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": null,
                    "args": (v6/*:: as any*/),
                    "filters": (v22/*:: as any*/),
                    "handle": "connection",
                    "key": "NftProfileImportCollectionViewNftList_items",
                    "kind": "LinkedHandle",
                    "name": "items"
                  },
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*:: as any*/),
                "concreteType": "NftTokenContractImport",
                "kind": "LinkedField",
                "name": "nftTokenContractImportById",
                "plural": false,
                "selections": [
                  {
                    "alias": "errorItems",
                    "args": (v24/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v25/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": null,
                    "args": (v26/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v21/*:: as any*/),
                    "storageKey": "items(first:20,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                  },
                  {
                    "alias": null,
                    "args": (v26/*:: as any*/),
                    "filters": (v22/*:: as any*/),
                    "handle": "connection",
                    "key": "NftProfileImportCollectionViewNftList_items",
                    "kind": "LinkedHandle",
                    "name": "items"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "importStatus",
                    "storageKey": null
                  },
                  (v19/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContract",
                    "kind": "LinkedField",
                    "name": "contract",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tokenStandard",
                        "storageKey": null
                      },
                      (v1/*:: as any*/),
                      (v9/*:: as any*/),
                      (v13/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "symbol",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "processingItems",
                    "args": [
                      (v23/*:: as any*/),
                      {
                        "kind": "Literal",
                        "name": "importStatuses",
                        "value": [
                          "NFT_ITEM_IMPORT_STATUS_PROCESSING"
                        ]
                      }
                    ],
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v25/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                  },
                  {
                    "alias": "completeItems",
                    "args": [
                      (v23/*:: as any*/),
                      {
                        "kind": "Literal",
                        "name": "importStatuses",
                        "value": [
                          "NFT_ITEM_IMPORT_STATUS_COMPLETE"
                        ]
                      }
                    ],
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v25/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
                  },
                  {
                    "alias": "failedItems",
                    "args": (v24/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v25/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": "description",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionDescription",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/575.0.0-2026-09-01T15:23:14.547Z/NftProfileImportCollectionViewRefetchQuery",
    "metadata": {},
    "name": "NftProfileImportCollectionViewRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9e5ba21abd63a05ec3ad42f43d731e88";

export default node;
